// src/AlertProvider.tsx
import { createContext } from "@julo-ui/context";
var [AlertProvider, useAlertContext] = createContext({
  name: "AlertContext",
  hookName: "useAlertContext",
  providerName: "<AlertProvider />"
});

export {
  AlertProvider,
  useAlertContext
};
